import { createSceneReducer } from 'reducers/reducers-util';
import registrationUiReducer from './reducers.ui';
import registrationDataReducer from './reducers.data';

export default createSceneReducer(
  registrationDataReducer,
  registrationUiReducer
);
